export default "__VITE_ASSET__3ccace7e__"